<section class="c-section c-section--first c-section--last c-section--open c-section--static">
	<div class="c-section__header" style="padding-bottom: 24px">
		<h1 class="c-section__title c-section__title--sm c-text c-text--center@md-and-up">
			{{ ('Concierge.Welcome' | translate) + (!!vm.user['parentBusinessUser']['businessName'] ? ('Concierge.Valued_Employee' | translate) + ' ' + vm.user['parentBusinessUser']['businessName'] : '') }}
		</h1>
	</div>
	<div class="c-section__content u-oh-visible">
		<div class="c-card">
			<div class="c-content c-content--xxl u-no-pt u-no-pb">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-100">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--center o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-ost-xxl u-osb-xxl">
								<div class="c-text c-text--center">
									<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/concierge.svg"/>
								</div>
								<p *ngIf="!vm.isClosed" class="c-text c-text--center c-text--md u-ost-lg">
									{{ 'Concierge.Your_Plan' | translate }} {{ 'Concierge.Enter_Concierge_Service' | translate }}
								</p>
								<p *ngIf="vm.isClosed" class="c-text c-text--center c-text--md u-ost-lg">
									{{ 'Concierge.Your_Plan' | translate }} {{ 'Concierge.We_Are_Closed' | translate }}
								</p>
								<div *ngIf="!vm.isClosed" class="c-text c-text--center u-ost-lg">
									<button type="button" (click)="vm.redirectToWordCLoud()" class="c-button c-button--s1 c-button--lg">
										{{ 'Concierge.Service' | translate }}
									</button>
								</div>
								<p *ngIf="vm.isClosed" class="c-text c-text--center c-text--xl c-text--main u-ost-lg">
									{{ 'Concierge.Weekdays_From' | translate }} {{ ' ' + vm.startTimeInHours + '-' + vm.endTimeInHours }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
